<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">项目开关</span>
      </div>
      <div class="query_box"></div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="setting_div">
          <div class="setting_title">禁止提交面试：</div>
          <div class="setting_right">
            <Switch style="width:45px;flex-shrink: 0;" true-color="#ff4949" v-model="no_interview"
              @on-change="nointerview_change">
              <template #open>
                <span>开</span>
              </template>
              <template #close>
                <span>关</span>
              </template>
            </Switch>
            <div class="jieshao_div">
              <span class="jieshao_span">说明：开关打开，则表示面试提报功能关闭，不接受任何面试预约，用于项目无需求场景</span>
            </div>
            <!-- <Poptip
              word-wrap
              width="200"
              trigger="hover"
              title="开关介绍"
              content="开关打开变为红色，表示面试提报功能关闭"
            >
              <div class="shuoming">查看说明<Icon type="md-help" /></div>
            </Poptip> -->
          </div>
        </div>
      </div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="setting_div">
          <div class="setting_title">禁止邀约在职人员：</div>
          <div class="setting_right">
            <Switch style="width:45px;flex-shrink: 0;" true-color="#ff4949" v-model="on_job_invite"
              @on-change="on_job_invite_change">
              <template #open>
                <span>开</span>
              </template>
              <template #close>
                <span>关</span>
              </template>
            </Switch>
            <div class="jieshao_div">
              <span class="jieshao_span">说明：开关打开，则本项目在职人员不可被招聘人员(内部)预约，用于保护在职人员</span>
            </div>


            <!-- <Poptip
              word-wrap
              width="200"
              trigger="hover"
              title="开关介绍"
              content="开关打开变为红色，招聘人员（内部）不可预约本项目在职人员"
            >
              <div class="shuoming">查看说明<Icon type="md-help" /></div>
            </Poptip> -->
          </div>
        </div>
      </div>
    </div>



    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="setting_div">
          <div class="setting_title">自动检测员工合同：</div>
          <div class="setting_right">
            <Switch style="width:45px;flex-shrink: 0;" true-color="#00cd66" v-model="check_contract_status"
              @on-change="check_contract_change">
              <template #open>
                <span>开</span>
              </template>
              <template #close>
                <span>关</span>
              </template>
            </Switch>
            <div class="jieshao_div">
              <span class="jieshao_span">说明：开关打开，则表示每周会定时检测员工合同情况，会将情况发送到消息通知中，用于检测项目合同情况</span>
            </div>
            <!-- <Poptip
              word-wrap
              width="200"
              trigger="hover"
              title="开关介绍"
              content="默认打开，打开时每周会定时检测员工合同情况，会将情况发送到消息中"
            >
              <div class="shuoming">查看说明<Icon type="md-help" /></div>
            </Poptip> -->
          </div>
        </div>
      </div>
    </div>


    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="setting_div">
          <div class="setting_title">发薪校验默认工资卡：</div>
          <div class="setting_right">
            <Switch style="width:45px;flex-shrink: 0;" true-color="#00cd66" v-model="check_payroll_mandates"
              @on-change="check_payroll_mandates_change">
              <template #open>
                <span>开</span>
              </template>
              <template #close>
                <span>关</span>
              </template>
            </Switch>
            <div class="jieshao_div">
              <span class="jieshao_span">说明：开关打开，则表示上传发薪表时检测工资卡，用于校验表格与员工默认工资卡是否一致</span>
            </div>


            <!-- <Poptip
              word-wrap
              width="200"
              trigger="hover"
              title="开关介绍"
              content="默认打开，打开时会检测发薪表委托代发情况"
            >
              <div class="shuoming">查看说明<Icon type="md-help" /></div>
            </Poptip> -->
          </div>
        </div>
      </div>
    </div>
    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="setting_div">
          <div class="setting_title">允许导入在职花名册：</div>
          <div class="setting_right">
            <Switch style="width:45px;flex-shrink: 0;" true-color="#00cd66" v-model="import_hmc_status"
              @on-change="import_hmc_change">
              <template #open>
                <span>开</span>
              </template>
              <template #close>
                <span>关</span>
              </template>
            </Switch>
            <div class="jieshao_div">
              <span class="jieshao_span">说明：开关打开，可进行导入花名册操作</span>
            </div>
            <!-- <Poptip
              word-wrap
              width="200"
              trigger="hover"
              title="开关介绍"
              content="默认打开，打开时每周会定时检测员工合同情况，会将情况发送到消息中"
            >
              <div class="shuoming">查看说明<Icon type="md-help" /></div>
            </Poptip> -->
          </div>
        </div>
      </div>
    </div>
    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="setting_div">
          <div class="setting_title">不校验入职身份证号：</div>
          <div class="setting_right">
            <Switch style="width:45px;flex-shrink: 0;" true-color="#00cd66" v-model="entry_check_idcard_status"
              @on-change="entry_change_idcard_change">
              <template #open>
                <span>开</span>
              </template>
              <template #close>
                <span>关</span>
              </template>
            </Switch>
            <div class="jieshao_div">
              <span class="jieshao_span">说明：开关打开，入职、离职无需完善身份证号也可操作</span>
            </div>
            <!-- <Poptip
              word-wrap
              width="200"
              trigger="hover"
              title="开关介绍"
              content="默认打开，打开时每周会定时检测员工合同情况，会将情况发送到消息中"
            >
              <div class="shuoming">查看说明<Icon type="md-help" /></div>
            </Poptip> -->
          </div>
        </div>
      </div>
    </div>


    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="setting_div">
          <div class="setting_title">离职通知员工：</div>
          <div class="setting_right">
            <Switch style="width:45px;flex-shrink: 0;" true-color="#00cd66" v-model="lizhi_status"
              @on-change="lizhi_status_change">
              <template #open>
                <span>开</span>
              </template>
              <template #close>
                <span>关</span>
              </template>
            </Switch>
            <div class="jieshao_div">
              <span class="jieshao_span">说明：开关打开，操作离职后会公众号通知员工</span>
            </div>
            <!-- <Poptip
              word-wrap
              width="200"
              trigger="hover"
              title="开关介绍"
              content="默认打开，打开时每周会定时检测员工合同情况，会将情况发送到消息中"
            >
              <div class="shuoming">查看说明<Icon type="md-help" /></div>
            </Poptip> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "project_setting",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      project_id: "",
      project_name: "",
      loading: false,
      // 不可预约
      no_interview: false,
      // 邀约在职
      on_job_invite: false,
      // 检测发薪表
      check_payroll_mandates: false,
      check_contract_status: false,
      import_hmc_status: false,
      entry_check_idcard_status: false,
      lizhi_status: false
    };
  },

  methods() { },
  methods: {

    lizhi_status_change(e) {
      console.log(e);
      var that = this;
      var obj = {
        project_id: this.project_id,
        lizhi_notify: e,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/update_lizhi_notify",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.get_setting_list();

          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    entry_change_idcard_change(e) {
      console.log(e);

      var that = this;
      var obj = {
        project_id: this.project_id,
        status: e,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/update_entry_check_idcard",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.get_setting_list();

          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    import_hmc_change(e) {
      console.log(e);

      var that = this;
      var obj = {
        project_id: this.project_id,
        status: e,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/update_import_hmc",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
          that.get_setting_list();
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    check_contract_change(e) {
      console.log(e);

      var that = this;
      var obj = {
        project_id: this.project_id,
        status: e,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/update_check_contract",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
          that.get_setting_list();
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    check_payroll_mandates_change(e) {
      console.log(e);

      var that = this;
      var obj = {
        project_id: this.project_id,
        status: e,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/update_check_payroll_mandates",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
          that.get_setting_list();
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;
      this.get_setting_list();
    },

    nointerview_change(e) {
      var that = this;
      var obj = {
        project_id: this.project_id,
        status: e,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/update_no_interview",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
          that.get_setting_list();
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },
    on_job_invite_change(e) {
      var that = this;
      var obj = {
        project_id: this.project_id,
        status: e,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/update_on_job_invite",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
          that.get_setting_list();
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    //获取设置列表
    get_setting_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_setting_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.no_interview = res.data.no_interview;
            that.on_job_invite = res.data.no_on_job_invite;
            that.check_payroll_mandates = res.data.check_payroll_mandates;
            that.check_contract_status = res.data.check_contract_status
            that.import_hmc_status = res.data.import_hmc_status
            that.entry_check_idcard_status = res.data.entry_check_idcard_status
            that.lizhi_status = res.data.lizhi_status
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.jieshao_div {
  margin-left: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 3px 5px;
}

.setting_right {
  display: flex;
  align-items: center;

  font-size: 12px;

}

.jieshao_span {
  color: #333;
  font-size: 12px;
  border-radius: 4px;


}

.shuoming {
  background: #f7e6e6;
  margin-left: 10px;
  color: #888;
  font-size: 12px;
  padding: 0 5px;
  border-radius: 3px;
  cursor: pointer;
}

.setting_div {
  padding-left: 20px;
  display: flex;
  align-items: center;
}

.setting_title {
  flex-shrink: 0;
  width: 160px;
}

.export_div {
  padding-top: 5px;
  align-items: center;
  display: flex;
  font-size: 13px;
  justify-content: flex-end;
  cursor: pointer;
  color: #0466dd;
}

.ratiospan {
  font-size: 18px;
  position: absolute;
  right: 20px;
  top: 8px;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 0px 0 0px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ececec;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.count_title3 {
  font-size: 13px;
  color: #0d35c4;
  margin-top: 5px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_title2 {
  font-size: 13px;
  color: #fff;
  margin-top: 5px;
}

.count_card {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
}

.count_card2 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  color: #fff;
  background-color: rgb(89, 146, 220);
  text-align: center;
}

.count_card3 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  color: #fff;
  background-color: rgb(248, 73, 47);
  text-align: center;
}

.data_div {
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
